import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
import ClubDetailsForm from './club/ClubDetailsForm';

const LeftSidebarCard = Loadable(lazy(() => import("./LeftSidebarCard")));
const UserProfile = Loadable(lazy(() => import("./user-profile/UserProfile")));

const pageLayoutRoutes = [
    {
        path: '/settings/account-settings',
        element: <LeftSidebarCard />,
    },
    {
        path: '/settings/user-profile',
        element: <UserProfile />,
    },
    {
        path: '/settings/client',
        element: <ClubDetailsForm />,
    },
]

export default pageLayoutRoutes
